module.exports = "/static/js/6e758902a272ef33c96486e2de2ca5f0.png";